import React from "react";
import ct from "class-types.macro";
import { BranchCategoryDetail } from "~/common/Store/models/Category";
import Breadcrumbs from "~/common/Breadcrumbs";
import Sidebar from "../Sidebar";
import BottomDescription from "../BottomDescription";
import RelatedCategoryCarousel from "../RelatedCategoryCarousel";
import CategoryGridItem from "./CategoryGridItem";
import TopProductsCarousel from "~/common/TopProductsCarousel/TopProductsCarousel";
import { usePageTracking } from "~/analytics/usePageTracking";
const BranchCategory = ({
  visibleText,
  hiddenText,
  children,
  seoCategoryProperties,
  categoryTopProducts,
  linkedResources,
  name,
  subtitle,
  bottomDescription,
  relatedCategories,
  parent,
  layoutConfiguration
}: BranchCategoryDetail) => {
  usePageTracking("CategoryPageEvent");
  const displayTopProductsInMainContainer = children.length > 0 && children.length < 30;
  const topProducts = categoryTopProducts?.map(x => x.product);
  const hideHiddenText = !displayTopProductsInMainContainer && seoCategoryProperties.showTopProducts && categoryTopProducts && categoryTopProducts.length > 0;
  return <>
      <Breadcrumbs breadcrumbs={layoutConfiguration.breadCrumb.items} data-sentry-element="Breadcrumbs" data-sentry-source-file="index.tsx" />
      <div className="container">
        <h1 className="page-header">{name}</h1>
        <div id="page" className="page-category fixed-side-right clears">
          <div id="main" role="main">
            <div className="ag ag-category-grid box">
              {children.map(x => <CategoryGridItem category={x} key={x.id} />)}
            </div>
            <div className="grid-module-blank">
              {displayTopProductsInMainContainer && !!topProducts?.length && <div className={ct("mb-0", "md:mb-3")} data-testid="Top Products">
                  <TopProductsCarousel topProducts={topProducts} itemWidth={ct("w-5/12", "xsl:w-40")} productListingView="topProductsCarousel" pageType="Category" />
                </div>}
              <RelatedCategoryCarousel relatedCategories={relatedCategories} categoryName={name} parentCategoryName={parent.name} data-sentry-element="RelatedCategoryCarousel" data-sentry-source-file="index.tsx" />
              <div>
                <BottomDescription bottomDescription={bottomDescription} data-sentry-element="BottomDescription" data-sentry-source-file="index.tsx" />
              </div>
            </div>
          </div>
          <div id="sidebar" className="aside">
            <Sidebar showTopProducts headline={subtitle} hiddenText={hiddenText} overflowText={hiddenText} visibleText={visibleText} hideHiddenText={hideHiddenText} linkedResources={linkedResources} categoryTopProducts={categoryTopProducts} displayTopProductsInMainContainer={displayTopProductsInMainContainer} data-sentry-element="Sidebar" data-sentry-source-file="index.tsx" />
          </div>
        </div>
      </div>
    </>;
};
export default BranchCategory;